module.exports = __webpack_public_path__ + "static/floor_preview__3-2ea09e90f8f6919365152b21e63adb33.png";